import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { CellContext, Tag } from '@optimus-web/core';
import { TableDataItem } from './types';

export const LegallyRequired = (props: CellContext<TableDataItem, unknown>) => {
    const { isLegallyRequired } = props.row.original;

    return isLegallyRequired ? (
        <Tag variant="info">
            <LocalizedText textKey={TextKey.Required} />
        </Tag>
    ) : null;
};
